export const STATIONS_COLOR = {
  bus: "#6909B4",
  metro: "#35C602",
  taxi: "#FFAD00",
  train: "#F01818",
  bicycle: "#4754CA",
  walking: "#1DAEEF",
  behamrah: "#00C19F",
};

export const STATIONS_SIZE = 40;
export const SMALL_STATIONS_SIZE = 20;

export const ROUTE_SIZE = 8;

export const MAP_CONTENTS_OPACITY = 0.5;
